import Joyride, { CallBackProps, STATUS, Placement } from "react-joyride";
import { Text } from "@atlas-int/ui";
import { useDataAvailability } from "@atlas-int/data";
import {zIndex, status} from "@atlas-int/tokens";

const getSteps = (latestYear: number | null) => [
  {
    target: ".viewSelector",
    content: (
      <div>
        <Text variant="heading-3">Start Your Exploration</Text>
        <br />
        <Text variant="body" style={{ textAlign: "left" }}>
          Begin building your visualization by selecting one of two dimensions
          to explore: a product or a location.
        </Text>
        <Text variant="body" style={{ textAlign: "left" }}>
          By selecting <b style={{ color: status.gold }}>Product</b> you can
          explore questions such as, what did China export or import to in{" "}
          {latestYear || "the most recent year"}?
        </Text>
        <Text variant="body" style={{ textAlign: "left" }}>
          By selecting <b style={{ color: status.gold }}>Location</b> you can
          explore questions such as, to which countries did China export bananas
          in {latestYear || "the most recent year"}?
        </Text>
      </div>
    ),
    disableBeacon: true,
  },
  {
    target: ".customizeVisualization",
    content: (
      <div>
        <Text variant="heading-3">Customize Your Visualization</Text>
        <br />
        <Text variant="body" style={{ textAlign: "left" }}>
          Use the dropdown menus to select the exporter and importer location or
          product, in a given year.
        </Text>
        <Text variant="body" style={{ textAlign: "left" }}>
          Click on Settings to customize trade and complexity visualizations
          even more.
        </Text>
      </div>
    ),
    disableBeacon: true,
  },
  {
    target: ".analyzeTradeFlows",
    content: (
      <div>
        <Text variant="heading-3">Analyze Trade Flows</Text>
        <br />
        <Text variant="body" style={{ textAlign: "left" }}>
          Use these 4 visualizations to analyze export or import flows.
        </Text>
      </div>
    ),
    disableBeacon: true,
    placement: "right-start" as Placement,
  },
  {
    target: ".analyzeCountryComplexity",
    content: (
      <div>
        <Text variant="heading-3">Analyze Country Complexity and Opportunities</Text>
        <br />
        <Text variant="body" style={{ textAlign: "left" }}>
          Use these 2 visualizations to analyze the{" "}
          <b style={{ color: status.gold }}>know how</b> of a location and its
          potential paths to diversification.
        </Text>
      </div>
    ),
    disableBeacon: true,
    placement: "right-end" as Placement,
  },
  {
    target: ".learnMoreAndShare",
    content: (
      <div>
        <Text variant="heading-3">Learn More and Share!</Text>
        <br />
        <Text variant="body" style={{ textAlign: "left" }}>
          You can always find this tutorial at the bottom left, along with
          important data notes, a glossary of terms and different ways to share
          Atlas information.
        </Text>
      </div>
    ),
    disableBeacon: true,
    placement: "right-end" as Placement,
  },
];

const Walkthrough = ({ setRunWalkthrough }) => {
  const { getLatestYear } = useDataAvailability();
  const latestYear = getLatestYear();

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status as any)) {
      setRunWalkthrough(false);
    }
  };

  const steps = getSteps(latestYear);
  const filteredSteps = steps.filter(({ target }) => {
    const element = document.querySelector<HTMLElement>(target as string);
    return element !== null && element.offsetParent !== null;
  });

  return (
    <Joyride
      steps={filteredSteps}
      styles={{
        options: {
          primaryColor: status.gold,
          zIndex: zIndex.navigation,
        },
      }}
      continuous={true}
      showProgress={true}
      spotlightClicks={true}
      spotlightPadding={10}
      floaterProps={{ disableAnimation: true }}
      callback={handleJoyrideCallback}
      showSkipButton
    />
  );
};
export default Walkthrough;
